<template>
  <div class="match-picker" :class="{ 'has-defender-tag': defenderLabel }">
    <div class="team-side">
      <div v-if="defenderLabel" class="defender-tag">{{ defenderLabel }}</div>
      <div
        class="team-card"
        :class="{
          'team-card-defender': highlightHome && !homeJerseyColor,
          'team-card-has-color': !!homeJerseyColor,
          'is-clickable': clickable
        }"
        :style="homeCardStyle"
        @click="onClickHome"
      >
        <span class="team-name">{{ displayHomeName }}</span>
        <img
          v-if="homeLogoUrl"
          class="team-logo"
          :src="homeLogoUrl"
          alt=""
        />
        <div v-else class="team-logo team-logo-placeholder" />
        <div
          v-if="homeJerseyColor"
          class="team-color-bar team-color-bar-right"
          :style="{ backgroundColor: homeJerseyColor }"
        />
        <img
          class="picker-arrow picker-arrow-left"
          :src="pickerArrowUrl"
          alt=""
        />
      </div>
    </div>
    <div class="vs-text">VS</div>
    <div
      class="team-card team-card-away"
      :class="{
        'team-card-defender': highlightAway && !awayJerseyColor,
        'team-card-has-color': !!awayJerseyColor,
        'is-clickable': clickable
      }"
      :style="awayCardStyle"
      @click="onClickAway"
    >
      <div
        v-if="awayJerseyColor"
        class="team-color-bar team-color-bar-left"
        :style="{ backgroundColor: awayJerseyColor }"
      />
      <img
        v-if="awayLogoUrl"
        class="team-logo"
        :src="awayLogoUrl"
        alt=""
      />
      <div v-else class="team-logo team-logo-placeholder" />
      <span class="team-name">{{ displayAwayName }}</span>
      <img
        class="picker-arrow picker-arrow-right"
        :src="pickerArrowUrl"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { resolveTeamLogoUrl } from '../utils/team-logo'

export default {
  name: 'WheelBattleMatchPicker',
  props: {
    matchLogo: {
      type: String,
      default: ''
    },
    homeTeam: {
      type: Object,
      default: function () {
        return {}
      }
    },
    awayTeam: {
      type: Object,
      default: function () {
        return {}
      }
    },
    homePlaceholder: {
      type: String,
      default: '-'
    },
    awayPlaceholder: {
      type: String,
      default: '-'
    },
    clickable: {
      type: Boolean,
      default: false
    },
    defenderLabel: {
      type: String,
      default: ''
    },
    highlightHome: {
      type: Boolean,
      default: false
    },
    highlightAway: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      pickerArrowUrl: 'https://images.snsports.cn/Fu1AHB6vwEv7KgPycv412DFssnV7'
    }
  },
  computed: {
    displayHomeName: function () {
      return (this.homeTeam && this.homeTeam.name) || this.homePlaceholder
    },
    displayAwayName: function () {
      return (this.awayTeam && this.awayTeam.name) || this.awayPlaceholder
    },
    homeLogoUrl: function () {
      return resolveTeamLogoUrl(this.homeTeam, this.matchLogo, 37, 37)
    },
    awayLogoUrl: function () {
      return resolveTeamLogoUrl(this.awayTeam, this.matchLogo, 37, 37)
    },
    homeJerseyColor: function () {
      return this.resolveJerseyColor(this.homeTeam)
    },
    awayJerseyColor: function () {
      return this.resolveJerseyColor(this.awayTeam)
    },
    homeCardStyle: function () {
      if (!this.homeJerseyColor) {
        return null
      }
      return { borderColor: this.homeJerseyColor }
    },
    awayCardStyle: function () {
      if (!this.awayJerseyColor) {
        return null
      }
      return { borderColor: this.awayJerseyColor }
    }
  },
  methods: {
    resolveJerseyColor: function (team) {
      if (!team || !team.clothesColor) {
        return ''
      }
      return String(team.clothesColor)
    },
    onClickHome: function () {
      if (this.clickable) {
        this.$emit('click-home')
      }
    },
    onClickAway: function () {
      if (this.clickable) {
        this.$emit('click-away')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.match-picker {
  height: 100px;
  padding: 0 16px;
  box-sizing: border-box;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.match-picker.has-defender-tag {
  padding-top: 8px;
}

.team-side {
  position: relative;
  flex-shrink: 0;
}

.defender-tag {
  position: absolute;
  top: -32px;
  left: 0;
  z-index: 1;
  width: 56px;
  height: 22px;
  border-radius: 5px;
  background: #B1B3B8;
  font-size: 12px;
  color: #555555;
  text-align: center;
  line-height: 22px;
}

.team-card {
  position: relative;
  flex-shrink: 0;
  width: 130px;
  height: 52px;
  padding: 0 8px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}

.team-card-has-color {
  border: 1px solid;
}

.team-card-defender {
  background: #e8f8ef;
}

.is-clickable:active {
  opacity: 0.85;
}

.team-card-away {
  flex-direction: row;
}

.team-color-bar {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 8px;
  z-index: 1;
}

.team-color-bar-right {
  right: 0;
}

.team-color-bar-left {
  left: 0;
}

.team-name {
  flex: 1;
  text-align: center;
  min-width: 0;
  font-size: 13px;
  color: #1d2129;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.team-logo {
  position: relative;
  z-index: 2;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-left: 6px;
  object-fit: cover;
  margin-right: 3px;
}

.team-card-away .team-logo {
  margin-left: 0;
  margin-right: 6px;
  margin-left: 3px;
}

.team-logo-placeholder {
  background: #e5e5e5;
}

.picker-arrow {
  position: absolute;
  bottom: -2px;
  width: 28px;
  height: 28px;
  display: block;
  z-index: 2;
}

.picker-arrow-left {
  left: -2px;
}

.picker-arrow-right {
  right: -2px;
  transform: scaleX(-1);
}

.vs-text {
  flex-shrink: 0;
  width: 36px;
  margin: 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #666;
  text-align: center;
}
</style>
